// Params
import useCurrentUser from '../hooks/useCurrentUser';
import useWindowDimensions from '../hooks/useWindowDimensions'

// Frontend
import { Grid, Cell } from 'react-foundation';
import { useLocation, Link } from 'react-router-dom';
import futureWorkDesignLogo from '../images/layout/header/GradientLogoMain.png';
import '../stylesheets/layout/header/Primary.css';
import '../stylesheets/components/navigation/Header.css';
import { Nav, Navbar, Offcanvas } from 'react-bootstrap';

import PropTypes from 'prop-types';

function Header({ onCurrentUserChange }) {
  const currentUser = useCurrentUser();
  const { width } = useWindowDimensions();

  function FwdLogo({ loggedIn }) {
    return (
      <Link
        to={loggedIn ? '/conversations' : '/'}
        className="primary-header__link"
        id="page-navigation-button--home"
      >
        <img
          src={futureWorkDesignLogo}
          loading="lazy"
          alt="Future Work Design"
          className="primary-header__image"
          style={{ width: '210px', height: '50px' }}
        />
      </Link>
    );
  };

  FwdLogo.propTypes = {
    loggedIn: PropTypes.any
  }

  function HeaderLogos({ loggedIn }) {
    return (
      <FwdLogo loggedIn={loggedIn} />
    );
  };

  HeaderLogos.propTypes = {
    loggedIn: PropTypes.any
  }

  function HeaderLinks({ role }) {
    return (
      <Navbar collapseOnSelect expand="xl" className="bg-body-tertiary">
        <Navbar.Brand style={{ paddingRight: '25px' }}>
          <HeaderLogos loggedIn={true} />
        </Navbar.Brand>        
        {width > 1200 && (
          <Navbar id="responsive-navbar-nav"
            style={{ paddingLeft: '-500px' }}>
            <Nav className="me-auto" style={{ whiteSpace: 'nowrap' }}>
              {(role === "Admin" || role === "SystemAdmin") && (
                <Link to="/admin" className="primary-header-navigation-list__link">
                  Admin Panel
                </Link>)}
              <Link to="/conversations" className="primary-header-navigation-list__link">
                Dashboard
              </Link>
              {(role === "Admin" || role === "SystemAdmin") && (
              <Link to="/reports" className="primary-header-navigation-list__link">
                Reporting
              </Link>)}
              <Link to="/pages/how-to-use-this-tool" className="primary-header-navigation-list__link">
                How to use this tool
              </Link>
              <Link to="/resources" className="primary-header-navigation-list__link">
                Knowledge Hub
              </Link>
              <Link to="/pages/about-fwd" className="primary-header-navigation-list__link">
                About
              </Link>
            </Nav>
            <Nav style={{ paddingLeft: '45px' }}>
              <div>
                <span className="primary-header__microcopy">
                  Logged in as: {currentUser.firstname}
                </span>
                <HeaderSessionsButton loggedIn={true} />
              </div>
            </Nav>
          </Navbar>
        )}
        {width <= 1200 && (
          <>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-xl`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-xl`}
              aria-labelledby={`offcanvasNavbarLabel-expand-xl`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title
                  id={`offcanvasNavbarLabel-expand-xl}`}
                  style={{ paddingLeft: '10px', paddingTop: '10px' }}
                >
                  <HeaderLogos loggedIn={true} />
                </Offcanvas.Title>
              </Offcanvas.Header>              
              <Offcanvas.Body>
                <Nav className="me-auto" style={{ whiteSpace: 'nowrap' }}>
                  {(role === "Admin" || role === "SystemAdmin") && (
                    <Link to="/admin" className="primary-header-navigation-list__link">
                      Admin Panel
                    </Link>)}
                  <Link to="/conversations" className="primary-header-navigation-list__link">
                    Dashboard
                  </Link>
                  <Link to="/reports" className="primary-header-navigation-list__link">
                    Reporting
                  </Link>
                  <Link to="/pages/how-to-use-this-tool" className="primary-header-navigation-list__link">
                    How to use this tool
                  </Link>
                  <Link to="/resources" className="primary-header-navigation-list__link">
                    Knowledge Hub
                  </Link>
                  <Link to="/pages/about-fwd" className="primary-header-navigation-list__link">
                    About Forward Together
                  </Link>
                </Nav>
                <Nav>
                  <span className="primary-header__microcopy" style={{ paddingTop: "25px", paddingBottom: "10px" }}>
                    Logged in as: {currentUser.firstname}
                  </span>
                  <HeaderSessionsButton loggedIn={true} />
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </>
        )}
      </Navbar>
    );
  };

  HeaderLinks.propTypes = {
    role: PropTypes.string
  }

  function HeaderSessionsButton({ loggedIn }) {
    const location = useLocation();
    return (
      <>
        {location.pathname !== "/postauthentication" && (
          <>
            {loggedIn && (
              <Link
                to="/sessions/destroy"
                className="page-content__button--medium"
                id="page-navigation-button--sessions"
              >
                Sign-Out
              </Link>
            )}

            {!loggedIn && (
              <Link
                to="/sessions/new"
                className="page-content__button--medium"
                id="page-navigation-button--sessions"
              >
                Sign In
              </Link>
            )}
          </>
        )}

      </>
    );
  };

  HeaderSessionsButton.propTypes = {
    loggedIn: PropTypes.any
  }

  const loggedOut = function () {
    return (
      <header className="primary-header-wrap">
        <div className="primary-header">
          <div className="grid-container">
            <Grid className="align-middle">
              <Cell small={12} large={6}>
                <HeaderLogos />
              </Cell>

              <Cell small={12} large={6} className="text-right">
                <HeaderSessionsButton loggedIn={false} />
              </Cell>
            </Grid>
          </div>
        </div>
      </header>
    );
  };

  const loggedIn = function (role) {
    return (
      <header className="primary-header-wrap">
        <div className="primary-header">
          <div className="grid-container">
            <HeaderLinks role={role} />
          </div>
        </div>
      </header >
    );
  };

  const currentUserHeader = function (roles) {
    let roleComponent;

    if (roles.includes('SystemAdmin')) {
      roleComponent = 'SystemAdmin';
    }

    if (roles.includes('Admin')) {
      roleComponent = 'Admin';
    }

    if (roles.includes('User')) {
      roleComponent = 'User';
    }

    return loggedIn(roleComponent);
  };

  const header = function () {
    let headerComponent;

    if (!currentUser || onCurrentUserChange) {
      headerComponent = loggedOut();
    } else {
      headerComponent = currentUserHeader(currentUser.roles.map((role) => role.roleName));
    }

    return headerComponent;
  };

  return header();
};

export default Header;